const HeroSection = () => (
  <>
    <section className="hero" style={{ backgroundImage: "url('assets/images/banners/matricula.png')" }}>
      <a href="https://wa.me/5562998271550" target='_blank' rel='noreferrer' className="cta-button">Faça sua Matrícula</a>
    </section>

    <div id='botao-mobile' style={{ display: 'flex', justifyContent: 'center', backgroundColor: '#F4F4F4' }}>
      <a id="botao-mobile" href="#diferenciais" className="cta-button">Saiba Mais</a>
    </div>
  </>
);

export default HeroSection;
